export default __webpack_public_path__ + "static/media/agencyAdvertCard.7763cff1.svg";